(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[474],{

/***/ 4558:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sobre-nos",
      function () {
        return __webpack_require__(3613);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SingleBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


function SingleBanner(param) {
    let { imageUrl  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: imageUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "dealership-hero position-relative overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "dl-hero-single",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "at_hero_slider",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "at-hero-banner",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: imageUrl,
                            alt: "banner",
                            width: 1440,
                            height: 350,
                            sizes: "100vw",
                            style: {
                                width: "100%",
                                height: "auto",
                                objectFit: "cover"
                            }
                        })
                    })
                })
            })
        }) : null
    });
}


/***/ }),

/***/ 3613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ AboutUsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/about-us/about-us.js


function AboutUs(param) {
    let { company  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "h3-about-section ptb-40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row justify-content-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-7",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "at-section-title text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "at-subtitle position-relative lead text-primary shape-primary",
                                            children: [
                                                "Escolha a ",
                                                company.nickName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "h1 mt-2 mb-4",
                                            children: "Por que nos escolher?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "fw-500 mb-0",
                                            children: "Ve\xedculos de proced\xeancia, excel\xeancia no atendimento e pre\xe7o justo s\xe3o os pilares de nossa empresa e receita do nosso sucesso."
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row justify-content-center mt-4 g-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-xl-4 col-lg-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "h2-about-item-box bg-white rounded position-relative z-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-green",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/img/icons/missao.svg",
                                                    alt: "miss\xe3o",
                                                    width: 40,
                                                    height: 40
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "mb-4 mt-20",
                                                children: "Miss\xe3o"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: company.mission ? company.mission.replaceAll("<br>", "\n").replaceAll(/(<([^>]+)>)/ig, "").split("\n").map((item, key)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            item,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                        ]
                                                    }, key);
                                                }) : ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-xl-4 col-lg-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "h2-about-item-box bg-white rounded position-relative z-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-ciano",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/img/icons/visao.svg",
                                                    alt: "vis\xe3o",
                                                    width: 40,
                                                    height: 40
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "mb-4 mt-20",
                                                children: "Vis\xe3o"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    textAlign: "center"
                                                },
                                                children: company.vision ? company.vision.replaceAll("<br>", "\n").replaceAll(/(<([^>]+)>)/ig, "").split("\n").map((item, key)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            item,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                        ]
                                                    }, key);
                                                }) : ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-xl-4 col-lg-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "h2-about-item-box bg-white rounded position-relative z-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-blue",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/img/icons/valores.svg",
                                                    alt: "valores",
                                                    width: 40,
                                                    height: 40
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "mb-4 mt-20",
                                                children: "Valores"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-0",
                                                children: company.values ? company.values.replaceAll("<br>", "\n").replaceAll(/(<([^>]+)>)/ig, "").split("\n").map((item, key)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            item,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                        ]
                                                    }, key);
                                                }) : ""
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "h3-progress pb-120",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-xl-7",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h3-progress-left position-relative pe-0 pe-lg-4",
                                    style: {
                                        height: "100%",
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/img/store.jpeg",
                                        alt: company.nickName,
                                        width: 1024,
                                        height: 683,
                                        sizes: "100vw",
                                        style: {
                                            width: "100%",
                                            height: "auto"
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-xl-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h3-progress-right mt-50 mt-xl-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "at-section-title",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "at-subtitle lead text-secondary shape-primary position-relative",
                                                children: [
                                                    "Sobre a ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mark", {
                                                        className: "bg-transparent text-primary p-0",
                                                        children: company.nickName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "h1 mt-3 mb-3",
                                                children: "Nossa prioridade \xe9 voc\xea!"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: company.about ? company.about.replaceAll("<br>", "\n").replaceAll(/(<([^>]+)>)/ig, "").split("\n").map((item, key)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            item,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                        ]
                                                    }, key);
                                                }) : ""
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/default/single-banner.js
var single_banner = __webpack_require__(5460);
// EXTERNAL MODULE: ./src/components/layout/footer.js
var footer = __webpack_require__(9432);
// EXTERNAL MODULE: ./src/components/layout/header.js
var header = __webpack_require__(392);
;// CONCATENATED MODULE: ./src/pages/sobre-nos/index.js






var __N_SSP = true;
function AboutUsPage(param) {
    let { companyGeneralData , banner  } = param;
    companyGeneralData = JSON.parse(companyGeneralData);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "".concat(companyGeneralData.company.nickName, " Revenda de ve\xedculos multimarcas, novos e semi-novos. Ve\xedculos com proced\xeancia e garantia.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "https://bndv.com.br"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "".concat(companyGeneralData.company.nickName.toUpperCase(), " - ").concat(companyGeneralData.company.city ? companyGeneralData.company.city : "", " - Sobre N\xf3s")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "main-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                        company: companyGeneralData.company
                    }),
                    banner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(single_banner/* default */.Z, {
                        imageUrl: banner.imageUrl
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs, {
                        company: companyGeneralData.company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {
                        company: companyGeneralData.company
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [959,822,774,888,179], function() { return __webpack_exec__(4558); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);